import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us-forth',
  templateUrl: './about-us-forth.component.html',
  styleUrls: ['./about-us-forth.component.css']
})
export class AboutUsForthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
